import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    Table,
    notification,
    Modal,
    Button,
    Image,
    Pagination,
    Input,
    Carousel,
    Tooltip,
    Select,
    message
} from "antd";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, EyeOutlined } from "@ant-design/icons";
import { baseUrl } from "../../config";
import { skeletonData } from "../../components/skeletons/Blog";
import moment from "moment";

const { Search } = Input;
const { confirm } = Modal;

function IdeaList() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userId = searchParams.get('user');
    const [userList, setUserList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [modalVisible, setModalVisible] = useState(false);
    const [privacy, setPrivacy] = useState('');
    const [titleName, setTitleName] = useState();
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [imageType, setImageType] = useState('');

    const columns = [
        {
            title: "#",
            dataIndex: "index",
            key: "index"
        },
        {
            title: "Title",
            dataIndex: "title",
            key: "title"
        },
        {
            title: "Slug",
            dataIndex: "slug",
            key: "slug"
        },
        {
            title: "Total Purchases",
            dataIndex: "totalPurchases",
            key: "totalPurchases",
            align: "center"
        },
        // {
        //     title: "Type",
        //     dataIndex: "type",
        //     key: "type"
        // },
        {
            title: "Preview",
            dataIndex: "preview_video",
            key: "preview_video"
        },
        {
            title: "Media Gallery",
            dataIndex: "images",
            key: "images"
        },
        // {
        //     title: "Short Content",
        //     dataIndex: "shortContent",
        //     key: "shortContent"
        // },
        {
            title: "Summary",
            dataIndex: "content",
            key: "content"
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description"
        },
        {
            title: "Category",
            dataIndex: "category",
            key: "category"
        },
        {
            title: "Tags",
            dataIndex: "tags",
            key: "content"
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type"
        },
        {
            title: "Price",
            dataIndex: "target_price",
            key: "target_price"
        },
        {
            title: "Created By",
            dataIndex: "createdBy",
            key: "createdBy"
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt"
        },
        {
            title: "Updated At",
            dataIndex: "updatedAt",
            key: "updatedAt"
        },
        {
            title: 'Status',
            dataIndex: 'enabled',
            fixed: 'right',
            key: 'enabled',
            render: (value, record) => {
                const isActive = record.enabled === true;

                return (
                    <Select
                        value={isActive ? "true" : "false"}
                        className={isActive ? "status-color-active" : "status-color-inactive"}
                        style={{
                            width: 120
                        }}
                        onChange={(newStatus) => handleStatusChange(record._id, newStatus)}
                    >
                        <Select.Option value="true">Active</Select.Option>
                        <Select.Option value="false">Inactive</Select.Option>
                    </Select>
                );
            }
        }


        // {
        //     title: "Action",
        //     key: "action",
        //     dataIndex: "action",
        // }
    ];

    useEffect(() => {
        getList()
    }, [searchTerm, currentPage, pageSize, userId])

    async function getList() {
        try {
            setLoading(true);

            const params = {
                page: currentPage,
                items: pageSize,
            };

            if (userId) {
                params.createdBy = userId;
            }

            // Check if search is not null or empty, then add it to params
            if (searchTerm && searchTerm.trim() !== '') {
                params.q = searchTerm;
                params.fields = 'title';
                // params.fields = 'name,email'; // Specify searchable fields
            }

            // Make API call to submit form data
            const response = await axios.get(`${baseUrl}/api/idea-admin`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
                params
            });
            if (response.data.success) {
                setUserList(response.data.result);
                setTotalUsers(response.data.pagination.count);
            } else {
                setUserList([])
            }
            // Handle success response from the API
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight' // You can adjust the placement as needed
            });
            // Handle error response from the API
        } finally {
            setLoading(false); // End loading
        }
    };

    async function handleDelete(id) {
        try {
            const response = await axios.delete(`${baseUrl}/api/blog/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
            });
            if (response.status === 200) {
                getList();
                notification.success({
                    message: 'Success',
                    description: 'Faq deleted successfully!',
                    placement: 'topRight'
                });
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };


    const showModal = (privacy, name) => {
        setTitleName(name);
        setPrivacy(privacy || '')
        setModalVisible(true);
    };

    const handleOk = () => {
        setModalVisible(false);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleSearch = (value) => {
        if (value.length >= 3 || value.length === 0) {
            setSearchTerm(value);
            setCurrentPage(1);
        }
    };

    const showImageModal = (images, type) => {
        setSelectedImages(images);
        setImageType(type);
        setImageModalVisible(true);
    };

    const handleStatusChange = async (ideaId, newStatus) => {
        try {
            // Optional: Call your backend to update the status
            const token = localStorage.getItem('accessToken'); // adjust the key if it's different
            const statusLatest = newStatus === "true" ? true : false
            const response = await axios.put(
                `${baseUrl}/api/change-status/${ideaId}`,
                { status: statusLatest }, // Convert string to boolean
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            message.success('Status updated successfully');

            // Refresh list or update state accordingly
            // Option 1: Refetch userList
            // Option 2: Update state manually
            setUserList(prev =>
                prev.map(user =>
                    user._id === ideaId ? { ...user, enabled: statusLatest } : user
                )
            );
        } catch (error) {
            console.error(error);
            setUserList(prev =>
                prev.map(user =>
                    user._id === ideaId ? { ...user, enabled: user.enabled } : user
                )
            );
            message.error('Failed to update status');
        }
    };


    return (
        <>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Idea Management"
                            extra={
                                <>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "space-between" }}>
                                        <Search
                                            placeholder="Search by title"
                                            onSearch={handleSearch}
                                            allowClear
                                            style={{ flex: 1, minWidth: "200px" }} // Makes search bar flexible
                                        />
                                    </div>
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={loading ? skeletonData : userList.map((user, index) => ({
                                        index: (currentPage - 1) * pageSize + index + 1,
                                        _id: user._id,
                                        title: (<Tooltip title={user.title}>
                                            <span>
                                                {user.title?.split(' ').slice(0, 3).join(' ')}
                                                {user.title?.split(' ').length > 3 ? '...' : ''}
                                            </span>
                                        </Tooltip>),
                                        preview_video: Array.isArray(user.preview_video) && user.preview_video.length > 0 ? (
                                            <div onClick={() => showImageModal(user.preview_video, 'Preview')} style={{ cursor: 'pointer' }}>
                                                <Carousel autoplay dots={false} style={{ width: 80 }}>
                                                    {user.preview_video.map((file, i) => {
                                                        const fileUrl = `${file}`;
                                                        const isVideo = /\.(mp4|webm|ogg|MOV)$/i.test(file);

                                                        return (
                                                            <div key={i}>
                                                                {isVideo ? (
                                                                    <video
                                                                        src={fileUrl}
                                                                        width={60}
                                                                        height={60}
                                                                        style={{ objectFit: 'cover' }}
                                                                        muted
                                                                        loop
                                                                        autoPlay
                                                                    />
                                                                ) : (
                                                                    <Image
                                                                        src={fileUrl}
                                                                        width={60}
                                                                        height={60}
                                                                        style={{ objectFit: 'cover' }}
                                                                        preview={false}
                                                                    />
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </Carousel>
                                            </div>
                                        ) : '-',
                                        images: Array.isArray(user.images) && user.images.length > 0 ? (
                                            <div onClick={() => showImageModal(user.images, 'Media Images')} style={{ cursor: 'pointer' }}>
                                                <Carousel autoplay dots={false} style={{ width: 80 }}>
                                                    {user.images.map((file, i) => {
                                                        const fileUrl = `${baseUrl}/${file}`;
                                                        const isVideo = /\.(mp4|webm|ogg|MOV)$/i.test(file);

                                                        return (
                                                            <div key={i}>
                                                                {isVideo ? (
                                                                    <video
                                                                        src={fileUrl}
                                                                        width={60}
                                                                        height={60}
                                                                        style={{ objectFit: 'cover' }}
                                                                        muted
                                                                        loop
                                                                        autoPlay
                                                                    />
                                                                ) : (
                                                                    <Image
                                                                        src={fileUrl}
                                                                        width={60}
                                                                        height={60}
                                                                        style={{ objectFit: 'cover' }}
                                                                        preview={false}
                                                                    />
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </Carousel>
                                            </div>
                                        ) : '-',
                                        slug: (<Tooltip title={user.slug}>
                                            <Link target="blank" to={`https://inventring.com/idea/${user.slug}`}>
                                                {user.slug?.split('-').slice(0, 3).join('-')}
                                                {user.slug?.split('-').length > 3 ? '...' : ''}
                                            </Link>
                                        </Tooltip>),
                                        totalPurchases: user.purchaseCount > 0 ? <Link to={`/idea-purchase?idea=${user?._id}`}>{user.purchaseCount}</Link> : '-',
                                        tags: user?.tags,
                                        category: user?.category_id?.title,
                                        type: user?.payment_type
                                            ? user.payment_type.charAt(0).toUpperCase() + user.payment_type.slice(1)
                                            : '',
                                        target_price: user?.target_price > 0 && user?.payment_type !== 'free'
                                            ? `€${user.target_price}`
                                            : '-',
                                        content: (
                                            <Button type="primary" onClick={() => showModal(user.summary, 'Content')}>
                                                <EyeOutlined />
                                            </Button>
                                        ),
                                        description: (
                                            <Button type="primary" onClick={() => showModal(user.description, 'Description')}>
                                                <EyeOutlined />
                                            </Button>
                                        ),
                                        createdBy: (
                                            <Link to={`/users/${user?.createdBy?._id}`}>{user?.createdBy?.firstName || ''} {user?.createdBy?.lastName || ''}</Link>
                                        ),
                                        createdAt: (
                                            <p>{moment(user.createdAt).format("MMMM DD, YYYY hh:mm A")}</p>
                                        ),
                                        updatedAt: (
                                            <p>{user.updatedAt ? moment(user.updatedAt).format("MMMM DD, YYYY hh:mm A") : '-'}</p>
                                        ),
                                        enabled: user.enabled
                                    }))}
                                    pagination={false}
                                    scroll={{ x: 'max-content' }}
                                    className="ant-border-space"
                                />
                            </div>
                            {/* Keep pagination outside the scrollable div */}
                            <div className="pagination-container">
                                <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={totalUsers}
                                    onChange={handlePageChange}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal
                title={`${titleName}`}
                visible={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <div className="author-info">
                    <div dangerouslySetInnerHTML={{ __html: privacy }} />
                </div>
            </Modal>
            <Modal
                title={imageType}
                visible={imageModalVisible}
                onCancel={() => setImageModalVisible(false)}
                footer={null}
                width={600}
                destroyOnClose
            >
                <Carousel autoplay>
                    {selectedImages.map((file, i) => {
                        const fileUrl = `${baseUrl}/${file}`;
                        const isVideo = /\.(mp4|webm|ogg|MOV)$/i.test(file); // check file extension

                        return (
                            <div key={i} style={{ textAlign: 'center' }}>
                                {isVideo ? (
                                    <video
                                        src={fileUrl}
                                        controls
                                        style={{ maxHeight: '400px', maxWidth: '100%', objectFit: 'contain' }}
                                    />
                                ) : (
                                    <Image
                                        src={fileUrl}
                                        alt={`media-${i}`}
                                        style={{ maxHeight: '400px', maxWidth: '100%', objectFit: 'contain' }}
                                    />
                                )}
                            </div>
                        );
                    })}
                </Carousel>
            </Modal>


        </>
    );
}

export default IdeaList;
